const React = require("react");
function IconExclamationMarkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fill: props.fill || "#232323",
    height: props.size || 24,
    size: props.size || 24,
    width: props.size || 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M52.325582.054113v4.6511628a45.348837 45.348837 0 1 1-4.651163 0V.054113a50 50 0 1 0 4.651163 0m-2.232556 26.720928c1.288372 0 2.325581 1.037209 2.325581 2.325581v32.55814c0 1.288372-1.037209 2.325581-2.325581 2.325581s-2.325581-1.037209-2.325581-2.325581v-32.55814c0-1.288372 1.037209-2.325581 2.325581-2.325581m2.127905 43.895354a2.3255814 2.3255814 0 0 1-2.325582 2.325581 2.3255814 2.3255814 0 0 1-2.325581-2.325581 2.3255814 2.3255814 0 0 1 2.325581-2.325582 2.3255814 2.3255814 0 0 1 2.325582 2.325582"
  }));
}
module.exports = IconExclamationMarkCircle;